import styled from "styled-components";

export const Section = styled.div`
  position: absolute;
  top: 250px;
  width: 80%;
  height: 300px;
  left: "50%";
  transform: "translate(-50%, -50%)";
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08),
    0px 8px 8px -4px rgba(16, 24, 40, 0.03);
`;

export const Title = styled.p`
  width: 135px;
  height: 22px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.01em;
`;

export const TitleAutocomplete = styled.p`
  width: 184px;
  height: 21px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
  color: #424248;
`;

export const CardInfoText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  display: flex;
  align-items: center;
  letter-spacing: -0.01em;
  color: #424248;
  font-variation-settings: "slnt" 0;
`;

export const CardInfoStatus = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  align-items: center;
  text-align: right;
  color: #646363;
`;

export const Foto = styled.img`
  height: 32px;
  width: 32px;
  border-radius: 16px;
`;

export const CardInfo = styled.div`
  display: flex;
  width: 100%;
  height: 65px;
  padding: 19px 13px;
  margin: 16px auto;
  align-items: center;
  background: #d5deff;
  border-radius: 12px;
  box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08),
    0px 8px 8px -4px rgba(16, 24, 40, 0.03);

  img {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin-right: 13.5px;
    box-shadow: 0px 20px 24px -4px rgba(16, 24, 40, 0.08),
      0px 8px 8px -4px rgba(16, 24, 40, 0.03);
  }
`;

export const Line = styled.div`
  width: 100%;
  border-radius: 50%;
  border: 1px solid #e9eaf4;
  background-color: #e9eaf4;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;
  width: 100%;
  gap: 12px;
`;

export const RowSpace = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BtnCancel = styled.button`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 20px;

  width: 100%;
  height: 43px;
  background: #ffffff;
  border: 1px solid #a3a3a6;
  border-radius: 8px;
  cursor: pointer;
`;

export const BtnConcluir = styled.button`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 18px;
  gap: 8px;
  height: 44px;
  width: 100%;
  color: #ffffff;
  background: #2d5bff;
  border: 1px solid #2d5bff;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  opacity: ${(props: any) => (props.disabled ? 0.4 : 1)};
  cursor: ${(props: any) => (props.disabled ? "select" : "pointer")};
`;

export const Modalstyle = {
  position: "absolute" as const,
  top: "360px",
  padding: "32px 32px",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "455px",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 2,
  boxShadow: 2,
};
